import { Pipe, PipeTransform } from '@angular/core';
import { NotificationCampaignTargetedActiveUsers } from '../../models/enums/notification.enums';

@Pipe({
  name: 'notificationCampaignTargetedActiveUsers',
})
export class NotificationCampaignTargetedActiveUsersPipe implements PipeTransform {
  transform(
    notificationCampaignTargetedActiveUsers: NotificationCampaignTargetedActiveUsers
  ): string {
    switch (notificationCampaignTargetedActiveUsers) {
      case NotificationCampaignTargetedActiveUsers.LOGGED_IN_LAST_3_MONTHS:
        return $localize`Actif les 3 derniers mois`;
      case NotificationCampaignTargetedActiveUsers.LOGGED_IN_LAST_6_MONTHS:
        return $localize`Actif les 6 derniers mois`;
      case NotificationCampaignTargetedActiveUsers.ALL:
        return $localize`Tous`;
      default:
        return '';
    }
  }
}
